export enum EVideoResolution {
  FULL_HD = "Res1920x1080",
  HD_READY = "Res1280x720",
  VGA = "Res640x480",
  SD = "Res640x360",
  CIF = "Res352x288"
}

export const BITRATE_720P = [512, 640, 768, 896, 1024, 1280, 1536, 1792, 2048, 4096];

export const BITRATE_480P = [256, 320, 384, 448, 512, 640, 768, 896, 1024, 1280];

export interface ICameraStreamSettings {
  isMain: boolean;
  isMainStr: number;
  resolution: EVideoResolution;
  bitrate: number;
  fps: number;
  keyFrameFrequency: number;
}

export interface ICameraSettings {
  cameraId: number;
  name: string;
  vendor: ECameraName;
  settings: ICameraStreamSettings[];
}

export enum ECameraName {
  Dahua = "Dahua",
  Uniview = "Uniview",
}

export enum EAspectRatio {
  AspectRatio16x9 = "AspectRatio16x9",
  AspectRatio3x4 = "AspectRatio3x4",
}

export interface VideoSettingsWrapper {
  useAdaptiveBitrate: boolean;
  cameras: ICameraSettings[];
}
